import styled from 'styled-components';
import { SpinnerStyled } from 'app/Components/BrokerSearch/styles';

export const SelectBroker = styled.div`
  .qmt-ui-input,
  .qmt-ui-input--active {
      border: none;
      height: auto;
      padding: 0;
      div:has(>input) {
          align-self: center;
      }
  }

  .qmt-ui-svg-icon,
  ${SpinnerStyled} {
      top: 0;
  }
`;
